import React from 'react';
import { Text, makeStyles } from '@fluentui/react-components';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  color?: string;
}

const useStyles = makeStyles({
  root: {
    backgroundColor: 'var(--color-surface)',
    border: '1px solid var(--color-border-light)',
    borderRadius: 'var(--radius-md)',
    padding: 'var(--space-lg)',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-xs)',
    // Allow the card to shrink inside its grid track so a long value
    // (e.g. a survey title) can't push the row past the screen edge.
    minWidth: 0,
  },
  label: {
    fontSize: '12px',
    fontWeight: '500',
    color: 'var(--color-text-secondary)',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  value: {
    fontSize: '28px',
    fontWeight: '600',
    lineHeight: '1.1',
    letterSpacing: '-0.5px',
    overflowWrap: 'anywhere',
    minWidth: 0,
  },
  subtitle: {
    fontSize: '12px',
    color: 'var(--color-text-tertiary)',
  },
});

export default function StatCard({ title, value, subtitle, color = 'var(--undp-primary)' }: StatCardProps) {
  const s = useStyles();

  return (
    <div className={s.root}>
      <Text className={s.label}>{title}</Text>
      <Text className={s.value} style={{ color }}>{value}</Text>
      {subtitle && <Text className={s.subtitle}>{subtitle}</Text>}
    </div>
  );
}
